// import React, { useState, useEffect } from 'react'
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { FaBullhorn } from "react-icons/fa";
// import { FaUser } from "react-icons/fa";
// import { FaList } from "react-icons/fa";
// import { FaLocationArrow } from "react-icons/fa";
// import { FaWhatsapp } from "react-icons/fa";
// import { FaInstagram } from "react-icons/fa";
// import { FaWifi } from "react-icons/fa";
// import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
// import { MdBatteryFull } from "react-icons/md";
// import { FaShop } from "react-icons/fa6";
// import { RxDotsVertical } from "react-icons/rx";
// import { CiFaceSmile } from "react-icons/ci";
// import { FaPaperclip } from "react-icons/fa";
// import { FaCamera } from "react-icons/fa";
// import { FaMicrophone } from "react-icons/fa";

// import axios from "axios";



// import Campaigndetails from './campaigndetails';
// import whatsappBgimage from '../images/whatsapp-mobile-image.png'
// import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
// import whatsappnotch from '../images/Wp-notch-image.png'
// import Whatsappicon from '../images/Whatsappicon.png'
// import notemplate from '../images/notemplate.png'
// import TemplateInformation from './TemplateInformation';

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(function (c) {
//                     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//                 })
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// function getUserIdFromTokenOrLocatorgarsotrga() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             const userId = decoded.id || decoded.userId || decoded._id;
//             return { userId, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         const userId = decoded.id || decoded.userId || decoded._id;
//         return { userId, token: rawToken };
//     }
//     return { userId: null, token: null };
// }


// function Campaign() {

//     const [Templateimformations, setTemplateimformatios] = useState(false)
//     const [whatsappData, setWhatsappData] = useState([]);
//     const [messageLimits, setMessageLimits] = useState([]); // <-- Store per WABA channel message limits
//     const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();

//     useEffect(() => {
//         const fetchWhatsappData = async () => {
//             try {
//                 const api_url = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
//                 const headers = token ? { Authorization: `${token}` } : {};
//                 const response = await axios.get(`${api_url}/auth/my-whatsapp`, { headers });
//                 setWhatsappData(Array.isArray(response.data) ? response.data : []);
//             } catch (err) {
//                 setWhatsappData([]);
//             }
//         };
//         fetchWhatsappData();
//     }, [token]);
//     return (
//         <>
//             <div className='w-[100%] md:pt-0   md:pl-6 pl-0'>
//                 <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1 dark:text-[#fff] mt-14 p-1 md:mt-0 md:p-0'>
//                     <FaArrowLeftLong />
//                     <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>
//                         Start Your Campaign
//                     </p>
//                     <FaBullhorn />
//                 </div>

//                 <div className='w-[100%] flex justify-between flex-col md:flex-row mt-4 md:p-0 p-2'>
//                     <div className='w-[100%] md:w-[73%] flex flex-col justify-center'>

//                         <div className='flex items-center justify-between md:justify-center shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md flex-wrap gap-4'>

//                             <div className='flex items-center justify-center'>
//                                 <div className='flex flex-col items-center justify-center'>
//                                     <div className='w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full bg-[#ed7b003b] flex justify-center items-center'>
//                                         <div className='w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full bg-[#ed7b00] flex justify-center items-center text-[#fff] text-[18px] md:text-[20px]'>
//                                             <FaUser />
//                                         </div>
//                                     </div>
//                                     <span className='text-[#ed7b00] font-semibold text-[12px] md:text-[13px]'>
//                                         Campaign
//                                     </span>
//                                 </div>
//                                 <div className='hidden lg:block w-[200px] bg-[#ed7b00] h-[4px] mt-[-20px]'></div>
//                             </div>

//                             <div className='flex items-center justify-center'>
//                                 <div className='flex flex-col items-center justify-center'>
//                                     <div className={`w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full flex 
//                                       ${Templateimformations ? 'bg-[#ed7b003b]' : ''}  justify-center items-center`}>
//                                         <div className={`w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full ${Templateimformations ? 'bg-[#ed7b00]' : 'bg-[#d2d2d2]'}  flex justify-center items-center text-[#fff] text-[18px] md:text-[20px]`}>
//                                             <FaList />
//                                         </div>
//                                     </div>
//                                     <span className={`${Templateimformations ? 'text-[#ed7b00]' : 'text-[#d2d2d2]'} font-semibold text-[12px] md:text-[13px]`}>
//                                         Template
//                                     </span>
//                                 </div>
//                                 <div className={`hidden lg:block w-[200px] ${Templateimformations ? 'bg-[#ed7b00]' : 'bg-[#d2d2d2]'}  h-[4px] mt-[-20px]`}></div>
//                             </div>

//                             <div className='flex items-center justify-center'>
//                                 <div className='flex flex-col items-center justify-center'>
//                                     <div className='w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full flex justify-center items-center'>
//                                         <div className='w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full bg-[#d2d2d2] flex justify-center items-center text-[#fff] text-[18px] md:text-[20px]'>
//                                             <FaLocationArrow />
//                                         </div>
//                                     </div>
//                                     <span className='text-[#d2d2d2] font-semibold text-[12px] md:text-[13px] text-center'>
//                                         Verify & Send
//                                     </span>
//                                 </div>
//                             </div>

//                         </div>
//                         {Templateimformations ? <TemplateInformation setTemplateimformatios={setTemplateimformatios} /> : <Campaigndetails setTemplateimformatios={setTemplateimformatios} />}

//                     </div>
//                     <div className='w-[100%] md:w-[26%] p-4  '>
//                         <div
//                             className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center  '
//                             style={{ backgroundImage: `url(${whatsappBgimage})` }}>
//                             <div className='w-[266.5px] bg-cover bg-center h-[570px] rounded-[40px]    '
//                                 style={{ backgroundImage: `url(${whatsappBodyBgimage})` }}>
//                                 <div className='bg-[linear-gradient(135deg,_#16697a_0%,_#1a4d5c_100%)] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px]  relative overflow-hidden  '>
//                                     <div className='w-[100%] flex justify-between px-2'>
//                                         <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                             <span>12:00</span>
//                                             <FaWhatsapp />
//                                             <FaInstagram />
//                                         </div>
//                                         <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px] ' />
//                                         <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                             <FaWifi />
//                                             <MdOutlineSignalCellularConnectedNoInternet4Bar />
//                                             <MdBatteryFull />
//                                         </div>
//                                     </div>
//                                     <div className='w-[100%] flex px-2 items-center py-1 gap-1'>
//                                         <div className='flex items-center text-[#fff] gap-1'>
//                                             <FaArrowLeftLong className='text-[28px]' />
//                                             <img src={Whatsappicon} alt="" className='w-10 h-10' />
//                                         </div>
//                                         <div className='flex flex-col '>
//                                             <span className='text-[12px] text-wrap text-[#fff] font-bold'>
//                                                 {whatsappData && whatsappData.length > 0 && whatsappData[0]['Display Name']
//                                                     ? whatsappData[0]['Display Name']
//                                                     : 'Business Name'}
//                                             </span>
                                       
//                                             <span className='text-[10px] text-wrap text-[#fff]'>Business Account</span>
//                                         </div>
//                                         <div className='flex flex-col gap-1 text-[#fff]'>
//                                             <FaShop />
//                                             <RxDotsVertical />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className=' w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>
//                                     <div className='bg-[#fff] w-[100%] p-2   '>
//                                         <img src={notemplate} alt="" className='object-cover' />
//                                     </div>
//                                     <div className='w-[100%] flex justify-between items-center gap-1'>
//                                         <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
//                                             <div className='flex items-center gap-2'>
//                                                 <CiFaceSmile />
//                                                 <span className='text-[#575656] text-[12px]'>Enter your message</span>
//                                             </div>
//                                             <div className='flex items-center gap-2 text-[#575656]'>
//                                                 <FaPaperclip />
//                                                 <FaCamera />
//                                             </div>
//                                         </div>
//                                         <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
//                                             <FaMicrophone />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </>
//     )
// }

// export default Campaign



// second part ===============================
// import React, { useState, useEffect } from 'react'
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { FaBullhorn } from "react-icons/fa";
// import { FaUser, FaList, FaLocationArrow, FaWhatsapp, FaInstagram, FaWifi } from "react-icons/fa";
// import { MdOutlineSignalCellularConnectedNoInternet4Bar, MdBatteryFull } from "react-icons/md";
// import { FaShop } from "react-icons/fa6";
// import { RxDotsVertical } from "react-icons/rx";
// import { CiFaceSmile } from "react-icons/ci";
// import { FaPaperclip, FaCamera, FaMicrophone } from "react-icons/fa";
// import axios from "axios";

// import Campaigndetails from './campaigndetails';
// import TemplateInformation from './TemplateInformation';
// import VerifySend from './VerifySend';

// import whatsappBgimage     from '../images/whatsapp-mobile-image.png'
// import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
// import whatsappnotch       from '../images/Wp-notch-image.png'
// import Whatsappicon        from '../images/Whatsappicon.png'
// import notemplate          from '../images/notemplate.png'

// const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch { return {}; }
// }

// function getUserIdFromToken() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// function Campaign() {
//     // ── Step: 1 = Campaign details, 2 = Template, 3 = Verify & Send
//     const [step, setStep] = useState(1);

//     // ── Shared campaign state (flows top-down through steps) ──────────────
//     const [campaignData, setCampaignData] = useState({
//         campaignName:    new Date().toLocaleString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit',
//             hour12: false
//         }).replace(/,/g, ''),
   
//         phoneNumberId:   '',    // selected channel's phone_number_id
//         wabaId:          '',    // selected channel's waba_id
//         channelLabel:    '',    // display label
//         numbers:         [],    // array of phone number strings to send to
//         groupName:       '',
//         scheduledTime:   '',
//     });

//     const [templateData, setTemplateData] = useState({
//         category:      '',
//         templateType:  'All',
//         templateName:  '',
//         language:      'en_US',
//         components:    [],      // raw Meta components for preview
//     });

//     // ── WhatsApp accounts ─────────────────────────────────────────────────
//     const [whatsappData, setWhatsappData] = useState([]);
//     const { token } = getUserIdFromToken();

//     useEffect(() => {
//         const fetchWhatsappData = async () => {
//             try {
//                 const headers = token ? { Authorization: token } : {};
//                 const response = await axios.get(`${API_URL}/auth/my-whatsapp`, { headers });
//                 setWhatsappData(Array.isArray(response.data) ? response.data : []);
//             } catch { setWhatsappData([]); }
//         };
//         fetchWhatsappData();
//     }, [token]);

//     // ── Preview: body text from selected template ─────────────────────────
//     const previewBody = templateData.components.find(c => c.type === 'BODY')?.text || '';
//     const previewHeader = templateData.components.find(c => c.type === 'HEADER')?.text || '';

//     // ── Step labels ───────────────────────────────────────────────────────
//     const steps = [
//         { label: 'Campaign',      icon: <FaUser />,          step: 1 },
//         { label: 'Template',      icon: <FaList />,          step: 2 },
//         { label: 'Verify & Send', icon: <FaLocationArrow />, step: 3 },
//     ];

//     return (
//         <div className='w-[100%] md:pt-0 md:pl-6 pl-0'>
//             {/* ── Page title ── */}
//             <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1 dark:text-[#fff] mt-14 p-1 md:mt-0 md:p-0'>
//                 <FaArrowLeftLong />
//                 <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>Start Your Campaign</p>
//                 <FaBullhorn />
//             </div>

//             <div className='w-[100%] flex justify-between flex-col md:flex-row mt-4 md:p-0 p-2'>
//                 {/* ── Left: Form steps ── */}
//                 <div className='w-[100%] md:w-[73%] flex flex-col justify-center'>

//                     {/* Step indicator */}
//                     <div className='flex items-center justify-between md:justify-center shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md flex-wrap gap-4'>
//                         {steps.map((s, i) => {
//                             const active = step >= s.step;
//                             return (
//                                 <div key={s.step} className='flex items-center justify-center'>
//                                     <div className='flex flex-col items-center justify-center'>
//                                         <div className={`w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full flex justify-center items-center ${active ? 'bg-[#ed7b003b]' : ''}`}>
//                                             <div className={`w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full flex justify-center items-center text-[#fff] text-[18px] md:text-[20px] ${active ? 'bg-[#ed7b00]' : 'bg-[#d2d2d2]'}`}>
//                                                 {s.icon}
//                                             </div>
//                                         </div>
//                                         <span className={`font-semibold text-[12px] md:text-[13px] text-center ${active ? 'text-[#ed7b00]' : 'text-[#d2d2d2]'}`}>
//                                             {s.label}
//                                         </span>
//                                     </div>
//                                     {/* Connector line (not after last) */}
//                                     {i < steps.length - 1 && (
//                                         <div className={`hidden lg:block w-[150px] xl:w-[200px] h-[4px] mt-[-20px] ${step > s.step ? 'bg-[#ed7b00]' : 'bg-[#d2d2d2]'}`}></div>
//                                     )}
//                                 </div>
//                             );
//                         })}
//                     </div>

//                     {/* Step content */}
//                     {step === 1 && (
//                         <Campaigndetails
//                             campaignData={campaignData}
//                             setCampaignData={setCampaignData}
//                             whatsappData={whatsappData}
//                             onNext={() => setStep(2)}
//                         />
//                     )}
//                     {step === 2 && (
//                         <TemplateInformation
//                             templateData={templateData}
//                             wabaId = {"me"}
//                             setTemplateData={setTemplateData}
//                             campaignData={campaignData}
//                             token={token}
//                             onNext={() => setStep(3)}
//                             onPrev={() => setStep(1)}
//                         />
//                     )}
//                     {step === 3 && (
//                         <VerifySend
//                             campaignData={campaignData}
//                             templateData={templateData}
//                             token={token}
//                             onPrev={() => setStep(2)}
//                             onSuccess={() => setStep(1)} // reset on success
//                         />
//                     )}
//                 </div>

//                 {/* ── Right: Phone preview ── */}
//                 <div className='w-[100%] md:w-[26%] p-4'>
//                     <div className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center'
//                         style={{ backgroundImage: `url(${whatsappBgimage})` }}>
//                         <div className='w-[266.5px] bg-cover bg-center h-[570px] rounded-[40px]'
//                             style={{ backgroundImage: `url(${whatsappBodyBgimage})` }}>
//                             {/* Phone header */}
//                             <div className='bg-[linear-gradient(135deg,_#16697a_0%,_#1a4d5c_100%)] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px] relative overflow-hidden'>
//                                 <div className='w-[100%] flex justify-between px-2'>
//                                     <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                         <span>12:00</span><FaWhatsapp /><FaInstagram />
//                                     </div>
//                                     <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px]' />
//                                     <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
//                                         <FaWifi /><MdOutlineSignalCellularConnectedNoInternet4Bar /><MdBatteryFull />
//                                     </div>
//                                 </div>
//                                 <div className='w-[100%] flex px-2 items-center py-1 gap-1'>
//                                     <div className='flex items-center text-[#fff] gap-1'>
//                                         <FaArrowLeftLong className='text-[28px]' />
//                                         <img src={Whatsappicon} alt="" className='w-10 h-10' />
//                                     </div>
//                                     <div className='flex flex-col'>
//                                         <span className='text-[12px] text-[#fff] font-bold'>
//                                             {whatsappData[0]?.['Display Name'] || 'Business Name'}
//                                         </span>
//                                         <span className='text-[10px] text-[#fff]'>Business Account</span>
//                                     </div>
//                                     <div className='flex flex-col gap-1 text-[#fff]'><FaShop /><RxDotsVertical /></div>
//                                 </div>
//                             </div>

//                             {/* Message preview */}
//                             <div className='w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>
//                                 <div className='bg-[#fff] w-[100%] p-2 rounded-lg'>
//                                     {templateData.templateName ? (
//                                         <div>
//                                             {previewHeader ? (
//                                                 <p className='text-[13px] font-bold text-[#1a1919] mb-1'>{previewHeader}</p>
//                                             ) : null}
//                                             <p className='text-[12px] text-[#1a1919] font-semibold whitespace-pre-line'>
//                                                 {previewBody || 'Template body will appear here'}
//                                             </p>
//                                             {templateData.components.find(c => c.type === 'FOOTER') && (
//                                                 <p className='text-[10px] text-[#808080] mt-1'>
//                                                     {templateData.components.find(c => c.type === 'FOOTER')?.text}
//                                                 </p>
//                                             )}
//                                             {(templateData.components.find(c => c.type === 'BUTTONS')?.buttons || []).map((btn, i) => (
//                                                 <div key={i} className='w-full flex justify-center mt-1 border-t border-[#eee] pt-1'>
//                                                     <span className='text-[11px] text-[#1D9E91] font-semibold'>{btn.text}</span>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     ) : (
//                                         <img src={notemplate} alt="" className='object-cover' />
//                                     )}
//                                 </div>

//                                 {/* Input bar */}
//                                 <div className='w-[100%] flex justify-between items-center gap-1'>
//                                     <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
//                                         <div className='flex items-center gap-2'>
//                                             <CiFaceSmile />
//                                             <span className='text-[#575656] text-[12px]'>Enter your message</span>
//                                         </div>
//                                         <div className='flex items-center gap-2 text-[#575656]'><FaPaperclip /><FaCamera /></div>
//                                     </div>
//                                     <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
//                                         <FaMicrophone />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Campaign;



import { useState, useEffect } from "react";
import axios from "axios";
import { FaArrowLeftLong, FaBullhorn, FaUser, FaList, FaLocationArrow } from "react-icons/fa6";
import { FaWhatsapp, FaInstagram, FaWifi, FaPaperclip, FaCamera, FaMicrophone } from "react-icons/fa";
import { MdOutlineSignalCellularConnectedNoInternet4Bar, MdBatteryFull } from "react-icons/md";
import { CiFaceSmile } from "react-icons/ci";
import { RxDotsVertical } from "react-icons/rx";
import { FaShop } from "react-icons/fa6";

import Campaigndetails from './campaigndetails';
import TemplateInformation from "./TemplateInformation";
import VerifySend from "./VerifySend";

import whatsappBgimage     from '../images/whatsapp-mobile-image.png'
import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
import whatsappnotch       from '../images/Wp-notch-image.png'
import Whatsappicon        from '../images/Whatsappicon.png'
import notemplate          from '../images/notemplate.png'



function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}
const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";

export default function Campaign() {
  // ── Step: 1 = Campaign details, 2 = Template, 3 = Verify & Send ───────────
  const [step, setStep] = useState(1);

  // ── Campaign state ─────────────────────────────────────────────────────────
  const [campaignData, setCampaignData] = useState({
    campaignName: new Date()
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(/,/g, ""),
    phoneNumberId: "",
    wabaId: "",
    channelLabel: "",
    numbers: [],        // final deduped array built by Campaigndetails
    groupName: "",
    scheduledTime: "",
  });

  const [templateData, setTemplateData] = useState({
    category: "",
    templateType: "All",
    templateName: "",
    language: "en_US",
    components: [],
  });

  // ── WhatsApp channels ──────────────────────────────────────────────────────
  const [whatsappData, setWhatsappData] = useState([]);

  // ── Contact groups (fetched from your groups API) ──────────────────────────
  // Expected shape: [{ id, name, numbers: ["+91...", ...] }]
  // Adjust the API endpoint and response mapping to match your backend.
  const [groups, setGroups] = useState([]);

  const { token } = getUserIdFromToken();

  useEffect(() => {
    const headers = token ? { Authorization: token } : {};

    // Fetch WhatsApp channels
    axios
      .get(`${API_URL}/auth/my-whatsapp`, { headers })
      .then((res) => setWhatsappData(Array.isArray(res.data) ? res.data : []))
      .catch(() => setWhatsappData([]));

    // Fetch contact groups
    // ↓ Change this endpoint to match your backend route for groups
    axios
      .get(`${API_URL}/auth/groups`, { headers })
      .then(async (res) => {
        const raw = Array.isArray(res.data) ? res.data : [];
        // For each group fetched, fetch its contacts (numbers)
        const groupPromises = raw.map(async (g) => {
          // g.id is the DB id from backend, g.group_name is name
          let numbers = [];
          try {
            const contactRes = await axios.get(`${API_URL}/auth/groups/${g.id}/contacts`, { headers });
            numbers = Array.isArray(contactRes.data)
              ? contactRes.data.map((c) => c.phone || c.number || c.mobile || "").filter(Boolean)
              : [];
          } catch (e) {
            numbers = [];
          }
          return {
            id: g.id,
            name: g.group_name || g.groupName || g.name,
            numbers,
            count: g.total_contacts || numbers.length || 0,
          };
        });

        Promise.all(groupPromises).then(setGroups).catch(() => setGroups([]));
      })
      .catch(() => setGroups([]));
  }, [token]);

  // ── Preview helpers ────────────────────────────────────────────────────────
  const previewBody =
    templateData.components.find((c) => c.type === "BODY")?.text || "";
  const previewHeader =
    templateData.components.find((c) => c.type === "HEADER")?.text || "";

  // ── Steps config ───────────────────────────────────────────────────────────
  const STEPS = [
    { label: "Campaign",      icon: <FaUser />,          step: 1 },
    { label: "Template",      icon: <FaList />,          step: 2 },
    { label: "Verify & Send", icon: <FaLocationArrow />, step: 3 },
  ];

  return (
    <div className="w-[100%] md:pt-0 md:pl-6 pl-0">
      {/* Page title */}
      <div className="w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1 dark:text-[#fff] mt-14 p-1 md:mt-0 md:p-0">
        <FaArrowLeftLong />
        <p className="text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]">
          Start Your Campaign
        </p>
        <FaBullhorn />
      </div>

      <div className="w-[100%] flex justify-between flex-col md:flex-row mt-4 md:p-0 p-2">
        {/* ── Left: Form steps ── */}
        <div className="w-[100%] md:w-[73%] flex flex-col justify-center">

          {/* Step indicator */}
          <div className="flex items-center justify-between md:justify-center shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md flex-wrap gap-4">
            {STEPS.map((s, i) => {
              const active = step >= s.step;
              return (
                <div key={s.step} className="flex items-center justify-center">
                  <div className="flex flex-col items-center justify-center">
                    <div className={`w-[60px] h-[60px] md:w-[70px] md:h-[70px] rounded-full flex justify-center items-center ${active ? "bg-[#ed7b003b]" : ""}`}>
                      <div className={`w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full flex justify-center items-center text-[#fff] text-[18px] md:text-[20px] ${active ? "bg-[#ed7b00]" : "bg-[#d2d2d2]"}`}>
                        {s.icon}
                      </div>
                    </div>
                    <span className={`font-semibold text-[12px] md:text-[13px] text-center ${active ? "text-[#ed7b00]" : "text-[#d2d2d2]"}`}>
                      {s.label}
                    </span>
                  </div>
                  {i < STEPS.length - 1 && (
                    <div className={`hidden lg:block w-[150px] xl:w-[200px] h-[4px] mt-[-20px] ${step > s.step ? "bg-[#ed7b00]" : "bg-[#d2d2d2]"}`} />
                  )}
                </div>
              );
            })}
          </div>

          {/* Step content */}
          {step === 1 && (
            <Campaigndetails
              campaignData={campaignData}
              setCampaignData={setCampaignData}
              whatsappData={whatsappData}
              groups={groups}            // ← pass groups here
              onNext={() => setStep(2)}
            />
          )}
          {step === 2 && (
            <TemplateInformation
              templateData={templateData}
              wabaId={"me"}
              setTemplateData={setTemplateData}
              campaignData={campaignData}
              token={token}
              onNext={() => setStep(3)}
              onPrev={() => setStep(1)}
            />
          )}
          {step === 3 && (
            <VerifySend
              campaignData={campaignData}
              templateData={templateData}
              token={token}
              onPrev={() => setStep(2)}
              onSuccess={() => {
                // Reset everything on success
                setStep(1);
                setCampaignData((prev) => ({
                  ...prev,
                  numbers: [],
                  groupName: "",
                  scheduledTime: "",
                }));
              }}
            />
          )}
        </div>

        {/* ── Right: Phone preview ── */}
        <div className="w-[100%] md:w-[26%] p-4">
          <div
            className="w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center"
            style={{ backgroundImage: `url(${whatsappBgimage})` }}
          >
            <div
              className="w-[266.5px] bg-cover bg-center h-[570px] rounded-[40px]"
              style={{ backgroundImage: `url(${whatsappBodyBgimage})` }}
            >
              {/* Phone header */}
              <div className="bg-[linear-gradient(135deg,_#16697a_0%,_#1a4d5c_100%)] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px] relative overflow-hidden">
                <div className="w-[100%] flex justify-between px-2">
                  <div className="flex items-center gap-2 text-[12px] text-[#fff]">
                    <span>12:00</span>
                    <FaWhatsapp />
                    <FaInstagram />
                  </div>
                  <img src={whatsappnotch} alt="" className="w-[100px] h-[20px] object-content mt-[-10px]" />
                  <div className="flex items-center gap-2 text-[12px] text-[#fff]">
                    <FaWifi />
                    <MdOutlineSignalCellularConnectedNoInternet4Bar />
                    <MdBatteryFull />
                  </div>
                </div>
                <div className="w-[100%] flex px-2 items-center py-1 gap-1">
                  <div className="flex items-center text-[#fff] gap-1">
                    <FaArrowLeftLong className="text-[28px]" />
                    <img src={Whatsappicon} alt="" className="w-10 h-10" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[12px] text-[#fff] font-bold">
                      {whatsappData[0]?.["Display Name"] || "Business Name"}
                    </span>
                    <span className="text-[10px] text-[#fff]">Business Account</span>
                  </div>
                  <div className="flex flex-col gap-1 text-[#fff]">
                    <FaShop />
                    <RxDotsVertical />
                  </div>
                </div>
              </div>

              {/* Message preview */}
              <div className="w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between">
                <div className="bg-[#fff] w-[100%] p-2 rounded-lg">
                  {templateData.templateName ? (
                    <div>
                      {previewHeader && (
                        <p className="text-[13px] font-bold text-[#1a1919] mb-1">{previewHeader}</p>
                      )}
                      <p className="text-[12px] text-[#1a1919] font-semibold whitespace-pre-line">
                        {previewBody || "Template body will appear here"}
                      </p>
                      {templateData.components.find((c) => c.type === "FOOTER") && (
                        <p className="text-[10px] text-[#808080] mt-1">
                          {templateData.components.find((c) => c.type === "FOOTER")?.text}
                        </p>
                      )}
                      {(templateData.components.find((c) => c.type === "BUTTONS")?.buttons || []).map(
                        (btn, i) => (
                          <div key={i} className="w-full flex justify-center mt-1 border-t border-[#eee] pt-1">
                            <span className="text-[11px] text-[#1D9E91] font-semibold">{btn.text}</span>
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <img src={notemplate} alt="" className="object-cover" />
                  )}
                </div>

                {/* Input bar */}
                <div className="w-[100%] flex justify-between items-center gap-1">
                  <div className="bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]">
                    <div className="flex items-center gap-2">
                      <CiFaceSmile />
                      <span className="text-[#575656] text-[12px]">Enter your message</span>
                    </div>
                    <div className="flex items-center gap-2 text-[#575656]">
                      <FaPaperclip />
                      <FaCamera />
                    </div>
                  </div>
                  <div className="bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]">
                    <FaMicrophone />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Live recipient count below preview */}
          {campaignData.numbers.length > 0 && (
            <div className="mt-3 text-center">
              <span className="inline-flex items-center gap-1.5 bg-[#e1f5ee] text-[#0f6e56] text-[12px] font-semibold px-4 py-1.5 rounded-full border border-[#9fe1cb]">
                📊 {campaignData.numbers.length.toLocaleString()} recipients selected
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}